module.exports = __webpack_public_path__ + "img/photo-0058.6bad6c12.jpg";